<div class="Container-Unauthorized">
  <nav class="Nav-bar">
    <div class="Left-Nav">
      <div class="Container-Logo">
        <div class="logo">
          <img src="./assets/Global/Icon_SINCO.png" alt="">
        </div>
        <div class="title">CDMS<span>Librerias</span></div>
      </div>
    </div>
    <div class="Right-Nav"></div>
  </nav>
  <div class="Container-Body">
    <div class="container-global-components">
      <div class="Left-Body">
        <div class="Content-Left">
          <div class="title">Sin autorización.</div>
          <div class="Subtitle">Lo sentimos, su solicitud no pudo ser procesada. Recargue la pagina si el problema
            persiste
            informe a su supervisor.</div>
          <div class="Description">
            Su solicitud no pudo ser procesada debido a que no lo encontramos en nuestra base de datos, de lo contrario
            no conocemos el problema. Intente acceder presionando el botón para reintentar el inicio de sesión.
          </div>
          <div class="Button">
            <button (click)="Reload()" class="btn-icon-text">
              <i class="fa-solid fa-rotate-right"></i><span class="text">Actualizar</span>
            </button>
          </div>
        </div>

      </div>
      <div class="Right-Body">
        <div class="Content-img">
          <img src="./assets/Global/Ilustrations/Unauthorized.png" alt="">
        </div>
      </div>
    </div>
  </div>
</div>